import { moment } from "./moment";

/**
 * This function is used to convert a datetime string to a format suitable for input.
 * It takes a datetime string as input and returns it in a format that can be used in an HTML datetime input.
 * If the input is not a valid date, it returns the original value.
 * @param value
 * @returns
 */
export function datetimeInputMiddleware(value: string): string {
	if (value.startsWith("invalid-")) return value;
	const m = moment(value);
	if (!m.isValid()) return value;
	return m.format("YYYY-MM-DDTHH:mm");
}

export function timeInputMiddleware(value: string): string {
	if (value.startsWith("invalid-")) return value;
	const m = moment(value);
	if (!m.isValid()) return value;
	return m.format("HH:mm");
}

/**
 * This function is used to convert a datetime string to a format suitable for output.
 * It takes a datetime string as input and returns it in PostgreSQL timestamp format.
 * If the input is not a valid date, it returns the original value.
 * @param value
 * @returns
 */
export function datetimeOutputMiddleware(value: string): string {
	if (value.startsWith("invalid-")) return value;
	const m = moment(value);
	if (!m.isValid()) return value;
	return m.postgresTimestamp();
}
